module.exports = __webpack_public_path__ + "static/media/cocoroboW.1f3901c2.svg";